import {
  SecuritySettingsDomainSectionFragment,
  SecuritySettingsSecuritySettingsPageFragment,
} from 'generated/resources/graphql'
import { CompanyConfigDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type TypedSecuritySettingsSecuritySettingsPageFragment =
  SecuritySettingsSecuritySettingsPageFragment

export type TypedSecuritySettingsSecurityDomainFragment = SecuritySettingsDomainSectionFragment

export function useCompanyConfig(companyId: string) {
  const { loading, data, error } = useQuery(CompanyConfigDocument, { variables: { companyId } })

  const companyConfig = data
    ? data.securitySettings.companyConfigsConnection.edges?.[0]?.node
    : undefined

  const canUpdateCompanyConfig = !!data?.securitySettings._policies.updateCompanyConfig.can

  const domainConfig = data
    ? data.authentication.domainsConnection.edges?.map((edge) => edge.node)
    : undefined
  const canBulkEditEmail = !!data?.authentication._policies.bulkEmailChange.can

  return {
    canBulkEditEmail,
    canUpdateCompanyConfig,
    loading,
    error,
    companyConfig,
    domainConfig,
  }
}
